import { render, staticRenderFns } from "./ForgotForm.vue?vue&type=template&id=7aa3c8e6&"
import script from "./ForgotForm.vue?vue&type=script&lang=js&"
export * from "./ForgotForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports